import '@babel/polyfill';
import '@babel/plugin-syntax-dynamic-import';
import * as conditioner from 'conditioner-core/conditioner-core.min';

import './polyfill/arrayFrom';
import './polyfill/arrayFind';
import './polyfill/dataset';

import Rgpd from './modules/rgpd';


document.addEventListener('DOMContentLoaded', function() {
    const hero = document.querySelector('.hero');
    const customCursor = document.querySelector('.custom-cursor');
    
    // Détection mobile
    const isMobile = window.innerWidth <= 768;
    
    // Types d'images disponibles
    const imageTypes = ['img1', 'img2', 'img3', 'img4', 'img5', 'img6', 'img7', 'img8', 'img9', 'img10', 'img11', 'img12', 'img13', 'img14', 'img15', 'img16', 'img17'];
    
    let isMouseInHero = false;
    let mouseX = 0;
    let mouseY = 0;
    let prevMouseX = 0;
    let prevMouseY = 0;
    let mouseVelocityX = 0;
    let mouseVelocityY = 0;
    
    // Optimisations performance
    let lastMouseMove = 0;
    let heroRect = hero ? hero.getBoundingClientRect() : null;
    
    // Fonction pour créer une image flottante optimisée
    function createFloatingImage(x, y, velocityX = 0, velocityY = 0) {
        // Désactiver les images flottantes sur mobile
        if (isMobile) return;
        
        const img = document.createElement('div');
        img.className = 'floating-image';
        
        // Sélectionner un type d'image aléatoire
        const randomType = imageTypes[Math.floor(Math.random() * imageTypes.length)];
        img.classList.add(randomType);
        
        // Positionner l'image avec left/top pour éviter les problèmes de positioning
        img.style.left = x + 'px';
        img.style.top = y + 'px';
        img.style.transform = 'translate3d(0, 0, 0) scale(0.5)'; // Force l'accélération matérielle + scale initial
        
        // Ajouter au DOM
        hero.appendChild(img);
        
        // Variables pour l'animation de suivi
        let currentX = x;
        let currentY = y;
        let targetX = x + velocityX * 2;
        let targetY = y + velocityY * 2;
        let animationId;
        let isActive = true;
        let scaleProgress = 0;
        
        // Animation d'apparition avec scale
        requestAnimationFrame(() => {
            img.classList.add('visible');
        });
        
        // Animation de suivi fluide
        function animateFollow() {
            if (!isActive) return;
            
            // Animation du scale de 0.5 à 1 (plus rapide)
            if (scaleProgress < 1) {
                scaleProgress += 0.1; // Augmenter plus rapidement
                scaleProgress = Math.min(scaleProgress, 1); // Limiter à 1
            }
            
            // Interpolation douce vers la position cible
            const ease = 0.08;
            currentX += (targetX - currentX) * ease;
            currentY += (targetY - currentY) * ease;
            
            // Ajouter une légère dérive dans la direction du mouvement
            currentX += velocityX * 0.1;
            currentY += velocityY * 0.1;
            
            // Appliquer la position avec left/top pour éviter les problèmes
            img.style.left = currentX + 'px';
            img.style.top = currentY + 'px';
            
            // Appliquer le scale avec un easing doux (de 0.5 à 1)
            const easeOutBack = (t) => {
                const c1 = 1.70158;
                const c3 = c1 + 1;
                return 1 + c3 * Math.pow(t - 1, 3) + c1 * Math.pow(t - 1, 2);
            };
            const currentScale = 0.5 + (0.5 * easeOutBack(scaleProgress));
            img.style.transform = `translate3d(0, 0, 0) scale(${currentScale})`;
            
            // Continuer l'animation si l'image est encore active
            if (isActive && img.parentNode) {
                animationId = requestAnimationFrame(animateFollow);
            }
        }
        
        // Démarrer l'animation de suivi
        animationId = requestAnimationFrame(animateFollow);
        
        // Supprimer après un délai aléatoire
        setTimeout(() => {
            isActive = false;
            img.classList.add('fade-out');
            
            if (animationId) {
                cancelAnimationFrame(animationId);
            }
            
            setTimeout(() => {
                if (img.parentNode) {
                    img.parentNode.removeChild(img);
                }
            }, 300);
        }, 400 + Math.random() * 400);
    }
    
    // Gestionnaire de mouvement de souris optimisé
    function handleMouseMove(e) {
        // Désactiver sur mobile
        if (isMobile) return;
        
        const now = performance.now();
        
        // Throttling à 60fps
        if (now - lastMouseMove < 16) return;
        lastMouseMove = now;
        
        // Mettre à jour les dimensions à chaque mouvement pour prendre en compte le scroll
        heroRect = hero.getBoundingClientRect();
        
        const newMouseX = e.clientX - heroRect.left;
        const newMouseY = e.clientY - heroRect.top;
        
        // Calculer la vélocité du curseur
        mouseVelocityX = newMouseX - mouseX;
        mouseVelocityY = newMouseY - mouseY;
        
        // Mettre à jour les positions
        prevMouseX = mouseX;
        prevMouseY = mouseY;
        mouseX = newMouseX;
        mouseY = newMouseY;
        
        // Mettre à jour le curseur personnalisé
        customCursor.style.left = e.clientX + 'px';
        customCursor.style.top = e.clientY + 'px';
        
        // Calculer la vitesse de déplacement de la souris
        const mouseSpeed = Math.sqrt(mouseVelocityX * mouseVelocityX + mouseVelocityY * mouseVelocityY);
        
        // Déterminer le nombre d'images basé sur la vitesse
        let imagesToCreate = 0;
        if (mouseSpeed > 80) {
            imagesToCreate = Math.floor(mouseSpeed / 80);
            imagesToCreate = Math.min(imagesToCreate, 1);
        } else if (mouseSpeed > 40) {
            imagesToCreate = Math.random() < 0.15 ? 1 : 0;
        } else if (mouseSpeed > 10) {
            imagesToCreate = Math.random() < 0.3 ? 1 : 0;
        }
        
        // Créer le nombre d'images déterminé
        for (let i = 0; i < imagesToCreate; i++) {
            setTimeout(() => {
                createFloatingImage(
                    e.clientX + (Math.random() - 0.5) * 50,
                    e.clientY + (Math.random() - 0.5) * 50,
                    mouseVelocityX + (Math.random() - 0.5) * 5,
                    mouseVelocityY + (Math.random() - 0.5) * 5
                );
            }, i * 50);
        }
    }
    
    // Mettre à jour heroRect quand la fenêtre est redimensionnée
    function updateHeroRect() {
        heroRect = hero.getBoundingClientRect();
    }
    
    // Gestionnaire d'entrée dans la zone hero
    function handleMouseEnter() {
        isMouseInHero = true;
        customCursor.style.opacity = '1';
        updateHeroRect(); // Mettre à jour les dimensions
    }
    
    // Gestionnaire de sortie de la zone hero
    function handleMouseLeave() {
        isMouseInHero = false;
        customCursor.style.opacity = '0';
    }
    
    // Ajouter les écouteurs d'événements seulement si hero existe
    if (hero) {
        hero.addEventListener('mousemove', handleMouseMove);
        hero.addEventListener('mouseenter', handleMouseEnter);
        hero.addEventListener('mouseleave', handleMouseLeave);
        
        // Mettre à jour les dimensions au redimensionnement
        window.addEventListener('resize', updateHeroRect);
        
        // Génération automatique supprimée - images uniquement au mouvement de souris
        
        // Effet de particules sur clic - explosion dans toute la div
        hero.addEventListener('click', function(e) {
            // Mettre à jour les dimensions au moment du clic
            heroRect = hero.getBoundingClientRect();
            
            const clickX = e.clientX - heroRect.left;
            const clickY = e.clientY - heroRect.top;
            
            // Créer plusieurs images dispersées dans toute la div hero (coordonnées absolues)
            for (let i = 0; i < 8; i++) {
                setTimeout(() => {
                    // Position aléatoire dans toute la div hero (coordonnées absolues)
                    const randomX = heroRect.left + Math.random() * heroRect.width;
                    const randomY = heroRect.top + Math.random() * heroRect.height;
                    
                    // Calculer la direction depuis le point de clic vers la position aléatoire
                    const directionX = randomX - e.clientX;
                    const directionY = randomY - e.clientY;
                    
                    // Normaliser et amplifier la vélocité pour l'effet d'explosion
                    const distance = Math.sqrt(directionX * directionX + directionY * directionY);
                    const normalizedVelX = (directionX / distance) * 15;
                    const normalizedVelY = (directionY / distance) * 15;
                    
                    createFloatingImage(
                        randomX,
                        randomY,
                        normalizedVelX,
                        normalizedVelY
                    );
                }, i * 150);
            }
        });
    }

    
    // === NOUVELLES ANIMATIONS ===
    
    // Variables pour les animations de lining
    let $lines = [];
    let threshold;

    const $window = window;
    const $p = document.querySelectorAll('p');

    // Fonction de gestion du scroll
    function handler() {
        // Vérifier que $lines existe et n'est pas vide
        if (!$lines || $lines.length === 0) return;
        
        const scrollTop = window.scrollY + threshold;
        $lines.forEach(line => {
            if (line.getBoundingClientRect().top + window.scrollY < scrollTop) {
                line.classList.add('visible');
            } else {
                line.classList.remove('visible');
            }
        });
    }

    // Fonction pour re-sélectionner les lignes
    function reline() {
        $lines = Array.from(document.querySelectorAll('.line'));
        handler();
    }

    // Fonction pour définir le seuil
    function thresholder() {
        threshold = window.innerHeight * 5 / 6;
    }

    // Événement personnalisé "afterlining"
    $p.forEach(p => {
        p.addEventListener('afterlining', reline);
    });

    // Ajout des écouteurs scroll et resize
    window.addEventListener('scroll', handler);
    window.addEventListener('resize', thresholder);

    // Animation des éléments de la liste cases-list
    let casesList = [];
    let casesListContainer = null;

    function initCasesList() {
        casesListContainer = document.querySelector('.cases-list');
        if (casesListContainer) {
            casesList = Array.from(casesListContainer.querySelectorAll('li'));
            
            // Initialiser le style des li
            casesList.forEach((li, index) => {
                li.style.opacity = '0';
                li.style.transform = 'perspective(1000px) rotateX(-90deg)';
                li.style.transformOrigin = 'center top';
                li.style.transition = 'none'; // Pas de transition pour un effet fluide au scroll
            });
        }
    }

    function animateCasesList() {
        if (!casesListContainer || casesList.length === 0) return;
        
        const windowHeight = window.innerHeight;
        
        // Animer chaque li en fonction de sa progression dans le viewport
        casesList.forEach((li, index) => {
            const rect = li.getBoundingClientRect();
            
            // Calculer la progression de l'élément dans le viewport
            let progress = 0;
            
            // Zone d'animation : courte et rapide
            const triggerStart = windowHeight; // Début de l'animation quand l'élément entre dans le viewport
            const triggerEnd = windowHeight * 0.7; // Fin de l'animation quand l'élément a parcouru 30% du viewport
            
            if (rect.top <= triggerStart && rect.top >= triggerEnd) {
                // L'élément est dans la zone d'animation
                progress = (triggerStart - rect.top) / (triggerStart - triggerEnd);
                progress = Math.max(0, Math.min(1, progress)); // Limiter entre 0 et 1
            } else if (rect.top < triggerEnd) {
                // L'élément est complètement visible
                progress = 1;
            } else {
                // L'élément n'est pas encore entré
                progress = 0;
            }
            
            // Appliquer la rotation et l'opacité basées sur la progression
            const rotation = -90 + (90 * progress); // De -90deg à 0deg
            const opacity = progress; // De 0 à 1
            
            li.style.opacity = opacity;
            li.style.transform = `perspective(1000px) rotateX(${rotation}deg)`;
        });
    }

    // Ajouter l'animation cases-list au scroll
    window.addEventListener('scroll', animateCasesList);

    // Gestion de l'image de projet avec Three.js
    let projectCanvas = null;
    let threeScene = null;
    let threeRenderer = null;
    let threeMaterial = null;
    let threeMesh = null;
    let threeCamera = null;
    let isImageVisible = false;
    let mouseVelocityXProject = 0;
    let mouseVelocityYProject = 0;
    let lastMouseXProject = 0;
    let lastMouseYProject = 0;
    let currentTime = 0;
    let glitchIntensity = 0;
    let glitchTimer = 0;
    let targetXProject = 0;
    let targetYProject = 0;
    let currentXProject = 0;
    let currentYProject = 0;
    
    // Variables pour l'effet glitch
    let isTransitioning = false;
    let transitionProgress = 0;
    let transitionSpeed = 0.06; // Plus rapide pour l'effet glitch
    let currentTexture = null;
    let nextTexture = null;

    function createProjectCanvas() {
        if (projectCanvas) return;
        
        // Créer le canvas
        projectCanvas = document.createElement('canvas');
        projectCanvas.className = 'project-canvas-cursor';
        projectCanvas.style.position = 'fixed';
        projectCanvas.style.pointerEvents = 'none';
        projectCanvas.style.zIndex = '1';
        projectCanvas.style.opacity = '0';
        projectCanvas.style.transition = 'opacity 0.3s ease-out';
        projectCanvas.style.width = '583px';
        projectCanvas.style.height = '300px';
        projectCanvas.style.transform = 'translate(-50%, -50%)';
        // projectCanvas.style.border = '2px solid red'; // Debug: bordure rouge
        // projectCanvas.style.backgroundColor = 'rgba(255, 255, 0, 0.5)'; // Debug: fond jaune semi-transparent
        
        document.body.appendChild(projectCanvas);
        
        // console.log('Canvas créé et ajouté au DOM:', projectCanvas);
        
        // Initialiser Three.js
        initThreeJS();
    }

    function initThreeJS() {
        // Vérifier que Three.js est chargé
        if (typeof THREE === 'undefined') {
            console.error('Three.js n\'est pas chargé');
            return;
        }
        
        // Scène
        threeScene = new THREE.Scene();
        
        // Caméra
        threeCamera = new THREE.OrthographicCamera(-1, 1, 1, -1, 0, 1);
        
        // Renderer avec meilleure qualité
        threeRenderer = new THREE.WebGLRenderer({
            canvas: projectCanvas,
            alpha: true,
            antialias: false, // Désactiver pour plus de netteté
            precision: 'highp'
        });
        
        // Taille haute résolution pour écrans retina
        const pixelRatio = Math.min(window.devicePixelRatio, 2);
        const canvasWidth = 583;
        const canvasHeight = 300;
        
        threeRenderer.setSize(canvasWidth, canvasHeight);
        threeRenderer.setPixelRatio(pixelRatio);
        
        // Shader avec effet de morphing
        const liquidShader = {
            uniforms: {
                uTexture: { value: null },
                uTextureNext: { value: null },
                uTime: { value: 0 },
                uTransition: { value: 0.0 },
                uMorphIntensity: { value: 0.0 }
            },
            vertexShader: `
                varying vec2 vUv;
                void main() {
                    vUv = uv;
                    gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
                }
            `,
            fragmentShader: `
                uniform sampler2D uTexture;
                uniform sampler2D uTextureNext;
                uniform float uTime;
                uniform float uTransition;
                uniform float uMorphIntensity;
                varying vec2 vUv;
                
                // Fonction de bruit pour l'effet morphing
                float noise(vec2 p) {
                    return fract(sin(dot(p, vec2(12.9898, 78.233))) * 43758.5453);
                }
                
                void main() {
                    vec2 uv = vUv;
                    
                    // Animation liquide de base plus prononcée
                    float wave1 = sin(uv.x * 5.0 + uTime * 1.0) * 0.015;
                    float wave2 = cos(uv.y * 3.5 + uTime * 0.7) * 0.015;
                    
                    // Ajout d'une deuxième couche d'ondulations
                    float wave3 = sin(uv.x * 8.0 + uTime * 1.5) * 0.008;
                    float wave4 = cos(uv.y * 6.0 + uTime * 1.2) * 0.008;
                    
                    uv += vec2(wave1 + wave3, wave2 + wave4);
                    
                    // Effet de glitch léger si transition en cours
                    vec2 glitchUv = uv;
                    if (uMorphIntensity > 0.0) {
                        // Décalages horizontaux par blocs (effet glitch classique)
                        float blockY = floor(uv.y * 8.0);
                        float blockRandom = noise(vec2(blockY, uTime * 10.0));
                        
                        // Décalage horizontal aléatoire léger
                        if (blockRandom > 0.85) {
                            float offset = (noise(vec2(blockY * 3.0, uTime * 8.0)) - 0.5) * uMorphIntensity * 0.02;
                            glitchUv.x += offset;
                        }
                        
                        // Scan lines subtiles
                        float scanLine = sin(uv.y * 200.0 + uTime * 5.0) * uMorphIntensity * 0.003;
                        glitchUv.x += scanLine;
                        
                        // Distortion numérique légère
                        float digitalNoise = noise(uv * 15.0 + uTime * 3.0) * uMorphIntensity * 0.008;
                        glitchUv += vec2(digitalNoise, digitalNoise * 0.5);
                        
                        // Décalage RGB léger (effet prisme)
                        float rgbShift = uMorphIntensity * 0.004;
                        glitchUv += vec2(rgbShift, 0.0);
                    }
                    
                    // Récupérer les couleurs avec effet glitch
                    vec4 color1, color2;
                    
                    if (uMorphIntensity > 0.0) {
                        // Aberration chromatique pour l'effet glitch
                        float chromaShift = uMorphIntensity * 0.003;
                        
                        // Séparer les canaux RGB pour l'effet glitch
                        float r1 = texture2D(uTexture, glitchUv + vec2(chromaShift, 0.0)).r;
                        float g1 = texture2D(uTexture, glitchUv).g;
                        float b1 = texture2D(uTexture, glitchUv - vec2(chromaShift, 0.0)).b;
                        color1 = vec4(r1, g1, b1, 1.0);
                        
                        float r2 = texture2D(uTextureNext, glitchUv + vec2(chromaShift, 0.0)).r;
                        float g2 = texture2D(uTextureNext, glitchUv).g;
                        float b2 = texture2D(uTextureNext, glitchUv - vec2(chromaShift, 0.0)).b;
                        color2 = vec4(r2, g2, b2, 1.0);
                    } else {
                        // Pas de glitch, échantillonnage normal
                        color1 = texture2D(uTexture, glitchUv);
                        color2 = texture2D(uTextureNext, glitchUv);
                    }
                    
                    // Interpolation avec courbe d'easing pour transition fluide
                    float easedTransition = smoothstep(0.0, 1.0, uTransition);
                    
                    // Mélange des couleurs avec effet de fondu glitch
                    vec4 finalColor = mix(color1, color2, easedTransition);
                    
                    // Effet de brillance plus prononcé
                    float glow = 1.0 + sin(uTime * 0.3) * 0.08 + cos(uTime * 0.5) * 0.05;
                    
                    // Intensité supplémentaire subtile pendant la transition
                    float transitionGlow = 1.0 + uMorphIntensity * 0.15;
                    
                    finalColor.rgb *= glow * transitionGlow;
                    
                    gl_FragColor = finalColor;
                }
            `
        };
        
        // Matériau avec shader
        threeMaterial = new THREE.ShaderMaterial(liquidShader);
        
        // Géométrie plane
        const geometry = new THREE.PlaneGeometry(2, 2);
        threeMesh = new THREE.Mesh(geometry, threeMaterial);
        threeScene.add(threeMesh);
        
        // Démarrer l'animation
        animateThreeJS();
    }

    function animateThreeJS() {
        if (!threeRenderer || !threeScene || !threeCamera) return;
        
        currentTime += 0.016; // ~60fps
        
        // Mettre à jour les uniformes du shader 
        if (threeMaterial && threeMaterial.uniforms) {
            // Mise à jour du temps pour l'animation
            if (threeMaterial.uniforms.uTime) {
                threeMaterial.uniforms.uTime.value = currentTime;
            }
            
            // Gestion de la transition morphing
            if (isTransitioning) {
                transitionProgress += transitionSpeed;
                
                if (transitionProgress >= 1.0) {
                    // Transition terminée
                    transitionProgress = 1.0;
                    isTransitioning = false;
                    
                    // Faire de la texture "next" la texture courante
                    currentTexture = nextTexture;
                    threeMaterial.uniforms.uTexture.value = currentTexture;
                    
                    // Réinitialiser les valeurs de transition
                    threeMaterial.uniforms.uTransition.value = 0;
                    threeMaterial.uniforms.uMorphIntensity.value = 0;
                    
                    // console.log('Transition glitch terminée');
                } else {
                    // Transition en cours
                    threeMaterial.uniforms.uTransition.value = transitionProgress;
                    
                    // Intensité glitch : pics aléatoires pour effet plus chaotique
                    let glitchIntensity = Math.sin(transitionProgress * Math.PI) * 1.2;
                    
                    // Ajouter des pics aléatoires pour l'effet glitch
                    if (Math.random() > 0.7) {
                        glitchIntensity *= 1.5 + Math.random() * 0.5;
                    }
                    
                    threeMaterial.uniforms.uMorphIntensity.value = glitchIntensity;
                }
            }
        }
        
        // Amortir la vélocité
        mouseVelocityXProject *= 0.95;
        mouseVelocityYProject *= 0.95;
        
        // Render
        threeRenderer.render(threeScene, threeCamera);
        
        // Continuer l'animation
        requestAnimationFrame(animateThreeJS);
    }

    function triggerGlitch(intensity = null) {
        // Déclencher un effet glitch avec intensité variable
        if (intensity === null) {
            glitchIntensity = 0.6 + Math.random() * 0.6; // Intensité entre 0.6 et 1.2
        } else {
            glitchIntensity = intensity;
        }
        glitchTimer = 0;
    }

    function showProjectImage(imageSrc, e) {
        if (!projectCanvas) createProjectCanvas();
        
        // Vérifier si on a déjà une texture active
        const hasCurrentTexture = currentTexture !== null;
        
        // Charger la nouvelle texture
        const loader = new THREE.TextureLoader();
        loader.load(
            imageSrc,
            (texture) => {
                // Configuration de la texture
                texture.wrapS = THREE.ClampToEdgeWrapping;
                texture.wrapT = THREE.ClampToEdgeWrapping;
                texture.minFilter = THREE.LinearFilter;
                texture.magFilter = THREE.LinearFilter;
                texture.generateMipmaps = false;
                texture.flipY = true;
                texture.needsUpdate = true;
                
                if (hasCurrentTexture && threeMaterial.uniforms.uTexture.value) {
                    // Il y a déjà une texture, démarrer la transition morphing
                    nextTexture = texture;
                    threeMaterial.uniforms.uTextureNext.value = nextTexture;
                    
                    // Démarrer la transition
                    isTransitioning = true;
                    transitionProgress = 0;
                    
                    // console.log('Transition glitch démarrée');
                } else {
                    // Première texture ou pas de texture courante
                    currentTexture = texture;
                    threeMaterial.uniforms.uTexture.value = currentTexture;
                    
                    // Pas de transition, affichage direct
                    threeMaterial.uniforms.uTransition.value = 0;
                    threeMaterial.uniforms.uMorphIntensity.value = 0;
                    
                    // console.log('Première texture chargée');
                }
            },
            (progress) => {
                console.log('Chargement en cours:', progress);
            },
            (error) => {
                // Erreur de chargement
                console.error('Erreur de chargement de la texture:', error, imageSrc);
                
                // Essayer une approche alternative avec une image HTML
                const img = new Image();
                img.crossOrigin = 'anonymous';
                img.onload = function() {
                    console.log('Image HTML chargée, création de texture...');
                    const texture = new THREE.Texture(img);
                    texture.needsUpdate = true;
                    threeMaterial.uniforms.uTexture.value = texture;
                    texture.wrapS = THREE.ClampToEdgeWrapping;
                    texture.wrapT = THREE.ClampToEdgeWrapping;
                    texture.minFilter = THREE.LinearFilter;
                    texture.magFilter = THREE.LinearFilter;
                    texture.flipY = true;
                };
                img.onerror = function() {
                    console.error('Impossible de charger l\'image via HTML img:', imageSrc);
                };
                img.src = imageSrc;
            }
        );
        
        // Positionner le canvas avec décalage initial
        const offsetX = 30; // Décalage horizontal
        const offsetY = -20; // Décalage vertical
        
        targetXProject = e.clientX + offsetX;
        targetYProject = e.clientY + offsetY;
        currentXProject = targetXProject;
        currentYProject = targetYProject;
        
        projectCanvas.style.left = currentXProject + 'px';
        projectCanvas.style.top = currentYProject + 'px';
        projectCanvas.style.opacity = '.7';
        projectCanvas.style.zIndex = '1'; // Derrière les projets
        
        // console.log('Canvas positionné à:', currentXProject, currentYProject, 'Opacity:', projectCanvas.style.opacity);
        
        // Initialiser les positions
        lastMouseXProject = e.clientX;
        lastMouseYProject = e.clientY;
        mouseVelocityXProject = 0;
        mouseVelocityYProject = 0;
        
        isImageVisible = true;
    }

    function hideProjectImage() {
        if (projectCanvas) {
            projectCanvas.style.opacity = '0';
            isImageVisible = false;
        }
    }

    function updateImagePosition(e) {
        if (projectCanvas && isImageVisible) {
            // Calculer la vélocité
            const currentVelX = e.clientX - lastMouseXProject;
            const currentVelY = e.clientY - lastMouseYProject;
            
            mouseVelocityXProject = mouseVelocityXProject * 0.8 + currentVelX * 0.2;
            mouseVelocityYProject = mouseVelocityYProject * 0.8 + currentVelY * 0.2;
            
            // Décalage dynamique basé sur la vélocité
            const baseOffsetX = 30;
            const baseOffsetY = -20;
            const velocityFactor = Math.sqrt(mouseVelocityXProject * mouseVelocityXProject + mouseVelocityYProject * mouseVelocityYProject) * 0.1;
            
            const dynamicOffsetX = baseOffsetX + mouseVelocityXProject * 0.3;
            const dynamicOffsetY = baseOffsetY + mouseVelocityYProject * 0.3;
            
            // Position cible avec décalage
            targetXProject = e.clientX + dynamicOffsetX;
            targetYProject = e.clientY + dynamicOffsetY;
            
            // Interpolation fluide vers la position cible
            const lerpFactor = 0.12; // Facteur de suivis (plus bas = plus fluide)
            currentXProject += (targetXProject - currentXProject) * lerpFactor;
            currentYProject += (targetYProject - currentYProject) * lerpFactor;
            
            // Appliquer la position
            projectCanvas.style.left = currentXProject + 'px';
            projectCanvas.style.top = currentYProject + 'px';
            
            // Sauvegarder la position
            lastMouseXProject = e.clientX;
            lastMouseYProject = e.clientY;
        }
    }

    function initProjectImageHover() {
        const listItems = document.querySelectorAll('.cases-list li[data-project-image]');
        let currentMouseX = 0;
        let currentMouseY = 0;
        let currentHoveredItem = null;
        
        // Fonction pour détecter quel élément est sous le curseur
        function checkElementUnderCursor() {
            let foundItem = null;
            
            // Parcourir tous les éléments et vérifier s'ils sont sous le curseur
            listItems.forEach(li => {
                const rect = li.getBoundingClientRect();
                if (currentMouseX >= rect.left && 
                    currentMouseX <= rect.right && 
                    currentMouseY >= rect.top && 
                    currentMouseY <= rect.bottom) {
                    foundItem = li;
                }
            });
            
            if (foundItem !== currentHoveredItem) {
                // Nouvel élément sous le curseur
                if (currentHoveredItem) {
                    hideProjectImage();
                }
                
                currentHoveredItem = foundItem;
                
                if (foundItem) {
                    const imageSrc = foundItem.getAttribute('data-project-image');
                    if (imageSrc) {
                        showProjectImage(imageSrc, { clientX: currentMouseX, clientY: currentMouseY });
                    }
                }
            }
        }
        
        // Initialiser la position de la souris dès le chargement
        document.addEventListener('mouseenter', function(e) {
            if (currentMouseX === 0 && currentMouseY === 0) {
                currentMouseX = e.clientX;
                currentMouseY = e.clientY;
            }
        });
        
        // Suivre la position de la souris globalement
        document.addEventListener('mousemove', function(e) {
            currentMouseX = e.clientX;
            currentMouseY = e.clientY;
            updateImagePosition(e);
            
            // Vérifier aussi pendant le mouvement de souris
            checkElementUnderCursor();
        });
        
        // Vérifier l'élément sous le curseur pendant le scroll avec throttling
        let scrollCheckTimeout = null;
        window.addEventListener('scroll', function() {
            if (currentMouseX > 0 && currentMouseY > 0) {
                // console.log('Scroll détecté, position souris:', currentMouseX, currentMouseY);
                // Immédiat pour une réponse rapide
                checkElementUnderCursor();
                
                // Et encore après un court délai pour s'assurer qu'on n'a rien manqué
                if (scrollCheckTimeout) clearTimeout(scrollCheckTimeout);
                scrollCheckTimeout = setTimeout(() => {
                    checkElementUnderCursor();
                }, 16); // ~60fps
            }
        });
        
        listItems.forEach(li => {
            li.addEventListener('mouseenter', function(e) {
                currentHoveredItem = this;
                const imageSrc = this.getAttribute('data-project-image');
                if (imageSrc) {
                    showProjectImage(imageSrc, e);
                }
            });

            li.addEventListener('mouseleave', function() {
                if (currentHoveredItem === this) {
                    currentHoveredItem = null;
                    hideProjectImage();
                }
            });

            li.addEventListener('mousemove', function(e) {
                updateImagePosition(e);
            });
        });
    }

    // Fonction pour gérer la classe scroll du header
    function initHeaderScroll() {
        const header = document.querySelector('header');
        
        if (!header) {
            console.warn('Header non trouvé');
            return;
        }
        
        function handleHeaderScroll() {
            const scrollY = window.scrollY;
            const viewportHeight = window.innerHeight - 50;
            
            if (scrollY > viewportHeight) {
                // Scroll dépasse 100vh, ajouter la classe
                header.classList.add('scroll');
            } else {
                // Scroll inférieur à 100vh, retirer la classe
                header.classList.remove('scroll');
            }
        }
        
        // Écouter l'événement scroll
        window.addEventListener('scroll', handleHeaderScroll);
        
        // Vérifier la position initiale
        handleHeaderScroll();
    }

    // Fonction pour gérer l'effet parallax des images du hero
    function initHeroParallax() {
        const containerHero = document.querySelector('.container-hero');
        const img1 = document.querySelector('.container-hero .img-1');
        const img2 = document.querySelector('.container-hero .img-2');
        const logo = document.querySelector('.container-hero .logo');
        const sentence = document.querySelector('.container-hero .sentence');
        
        if (!containerHero || !img1 || !img2) {
            console.warn('Éléments du hero parallax non trouvés');
            return;
        }
        
        // Configuration différente pour chaque élément
        const speed1 = 0.15;  // img-1 : mouvement modéré
        const speed2 = 0.35;  // img-2 : mouvement plus rapide
        const speedLogo = 0.08; // logo : mouvement très léger
        const speedSentence = 0.8; // sentence : défilement horizontal rapide
        
        // Variables pour l'effet de flottement
        let floatTime = 0;
        const floatAmplitude = 20; // Amplitude du flottement en pixels (plus visible)
        const floatSpeed = 0.001; // Vitesse du flottement
        
        // Valeurs aléatoires pour différencier les deux images
        const random1 = {
            freqX: 0.3 + Math.random() * 0.4,
            freqY: 0.2 + Math.random() * 0.3,
            phaseX: Math.random() * Math.PI * 2,
            phaseY: Math.random() * Math.PI * 2,
            ampX: 0.8 + Math.random() * 0.4,
            ampY: 0.6 + Math.random() * 0.4
        };
        
        const random2 = {
            freqX: 0.4 + Math.random() * 0.5,
            freqY: 0.3 + Math.random() * 0.4,
            phaseX: Math.random() * Math.PI * 2,
            phaseY: Math.random() * Math.PI * 2,
            ampX: 0.9 + Math.random() * 0.5,
            ampY: 0.7 + Math.random() * 0.5
        };
        
        // Boucle d'animation unique pour flottement + parallax
        let lastTime = performance.now();
        
        function animate(currentTime) {
            const deltaTime = currentTime - lastTime;
            lastTime = currentTime;
            
            // Mettre à jour le temps de flottement
            floatTime += floatSpeed * deltaTime;
            
            const scrollY = window.scrollY;
            
            // Effet de flottement avec paramètres aléatoires pour chaque image
            const floatX1 = Math.sin(floatTime * random1.freqX + random1.phaseX) * floatAmplitude * random1.ampX;
            const floatY1 = Math.cos(floatTime * random1.freqY + random1.phaseY) * floatAmplitude * random1.ampY;
            
            const floatX2 = Math.sin(floatTime * random2.freqX + random2.phaseX) * floatAmplitude * random2.ampX;
            const floatY2 = Math.cos(floatTime * random2.freqY + random2.phaseY) * floatAmplitude * random2.ampY;
            
            // img-1 monte plus lentement + flottement
            const translateY1 = scrollY * speed1;
            
            // img-2 monte plus vite avec un léger décalage horizontal + flottement
            const translateY2 = scrollY * speed2;
            const translateX2 = scrollY * 0.05;
            
            // Sentence : défile horizontalement vers la gauche
            const translateXSentence = scrollY * speedSentence;
            
            img1.style.transform = `translate3d(${floatX1}px, ${-translateY1 + floatY1}px, 0)`;
            img2.style.transform = `translate3d(${-translateX2 + floatX2}px, ${-translateY2 + floatY2}px, 0)`;
            
            // Logo parallax désactivé car il a son propre wrapper maintenant
            
            if (sentence) {
                sentence.style.transform = `translate3d(-${translateXSentence}px, 0, 0)`;
            }
            
            requestAnimationFrame(animate);
        }
        
        // Démarrer l'animation
        requestAnimationFrame(animate);
    }

    // Fonction pour gérer le parallax de img-bio
    function initBioParallax() {
        const imgBio = document.querySelector('.section-bio .img-bio');
        
        if (!imgBio) {
            return;
        }
        
        // Vitesse du parallax (léger)
        const speedBio = 0.08;
        
        function handleBioScroll() {
            const rect = imgBio.getBoundingClientRect();
            const windowHeight = window.innerHeight;
            
            // Calculer seulement quand l'élément est visible
            if (rect.top < windowHeight && rect.bottom > 0) {
                // Position relative au centre de l'écran
                const elementCenter = rect.top + rect.height / 2;
                const screenCenter = windowHeight / 2;
                const offset = (elementCenter - screenCenter) * speedBio;
                
                // Conserver le translateY(-50%) pour le centrage + ajouter le parallax
                imgBio.style.transform = `translateY(-50%) translate3d(0, ${offset}px, 0)`;
            }
        }
        
        window.addEventListener('scroll', handleBioScroll, { passive: true });
        handleBioScroll();
    }

    // Fonction pour le défilement de la sentence dans container-sound
    function initSoundSentenceScroll() {
        const containerSound = document.querySelector('.container-sound');
        const sentenceSound = document.querySelector('.container-sound .sentence');
        const bgSounds = document.querySelector('.container-sound .bg-sounds');
        const choice2 = document.querySelector('.container-sound .choice-2');
        
        if (!containerSound || !sentenceSound) {
            return;
        }
        
        // Vitesse de défilement sentence
        const speedSentence = 0.5;
        // Vitesse parallax bg-sounds (léger)
        const speedBgSounds = 0.1;
        // Vitesse parallax choice-2 (léger)
        const speedChoice2 = 0.08;
        
        function handleSoundScroll() {
            const rect = containerSound.getBoundingClientRect();
            const windowHeight = window.innerHeight;
            
            // Calculer seulement quand l'élément est visible
            if (rect.top < windowHeight && rect.bottom > 0) {
                // Position relative au viewport
                const scrollProgress = (windowHeight - rect.top);
                
                // Sentence : défile horizontalement
                const translateX = scrollProgress * speedSentence;
                sentenceSound.style.transform = `translate3d(-${translateX}px, 0, 0)`;
                
                // bg-sounds : parallax vertical léger - désactivé sur mobile
                if (bgSounds && window.innerWidth > 768) {
                    const elementCenter = rect.top + rect.height / 2;
                    const screenCenter = windowHeight / 2;
                    const offsetY = (elementCenter - screenCenter) * speedBgSounds;
                    bgSounds.style.transform = `translate3d(0, ${offsetY}px, 0)`;
                }
                
                // choice-2 : parallax vertical léger (monte plus vite) - désactivé sur mobile
                if (choice2 && window.innerWidth > 768) {
                    const offsetY2 = scrollProgress * speedChoice2;
                    choice2.style.transform = `translate3d(0, -${offsetY2}px, 0)`;
                }
            }
        }
        
        window.addEventListener('scroll', handleSoundScroll, { passive: true });
        handleSoundScroll();
    }

    // Fonction pour le parallax sur contact title-img
    function initContactParallax() {
        const titleImg = document.querySelector('.contact .title-img');
        
        if (!titleImg) {
            return;
        }
        
        // Vitesse du parallax (léger)
        const speed = 0.08;
        
        function handleContactScroll() {
            // Désactiver le parallax sur mobile
            if (window.innerWidth <= 768) {
                titleImg.style.transform = '';
                return;
            }
            
            const rect = titleImg.getBoundingClientRect();
            const windowHeight = window.innerHeight;
            
            // Calculer seulement quand l'élément est visible
            if (rect.top < windowHeight && rect.bottom > 0) {
                const scrollProgress = (windowHeight - rect.top);
                const offsetY = scrollProgress * speed;
                
                titleImg.style.transform = `translate3d(0, -${offsetY}px, 0)`;
            }
        }
        
        window.addEventListener('scroll', handleContactScroll, { passive: true });
        handleContactScroll();
    }

    // Fonction pour l'effet d'écriture sur text-intro
    function initTextIntroTyping() {
        const textIntro = document.querySelector('.container-sound .text-intro');
        
        if (!textIntro) {
            return;
        }
        
        // Stocker le texte original
        const originalText = textIntro.textContent.trim();
        
        // Envelopper chaque caractère dans un span avec opacité 0
        let wrappedHTML = '';
        for (let i = 0; i < originalText.length; i++) {
            const char = originalText[i];
            if (char === ' ') {
                // Garder l'espace normal pour permettre le retour à la ligne
                wrappedHTML += ' ';
            } else {
                wrappedHTML += `<span style="opacity: 0; transition: opacity 0.15s ease-out;">${char}</span>`;
            }
        }
        textIntro.innerHTML = wrappedHTML;
        
        let hasAnimated = false;
        
        // Vitesse d'apparition (ms entre chaque caractère)
        const typingSpeed = 10;
        
        function revealText() {
            const spans = textIntro.querySelectorAll('span');
            spans.forEach((span, index) => {
                setTimeout(() => {
                    span.style.opacity = '1';
                }, index * typingSpeed);
            });
        }
        
        function checkVisibility() {
            if (hasAnimated) return;
            
            const rect = textIntro.getBoundingClientRect();
            const windowHeight = window.innerHeight;
            
            // Déclencher quand l'élément atteint 80% du viewport
            if (rect.top < windowHeight * 0.8) {
                hasAnimated = true;
                revealText();
                // Retirer l'écouteur une fois l'animation déclenchée
                window.removeEventListener('scroll', checkVisibility);
            }
        }
        
        window.addEventListener('scroll', checkVisibility, { passive: true });
        // Vérifier au chargement
        checkVisibility();
    }

    // Fonction pour l'animation du loader
    function initLoaderAnimation() {
        const containerGif = document.querySelector('.container-gif');
        const loader = document.querySelector('.loader');
        const gifImg = containerGif ? containerGif.querySelector('img') : null;
        
        if (!containerGif || !loader || !gifImg) {
            return;
        }
        
        // Remettre le scroll à 0 au chargement
        window.scrollTo(0, 0);
        
        // Bloquer le scroll pendant le loader
        document.body.style.overflow = 'hidden';
        document.documentElement.style.overflow = 'hidden';
        
        // S'assurer que le container est centré
        containerGif.style.cssText = `
            position: fixed;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            transform-origin: center center;
        `;
        
        // Cacher les éléments du hero au début (y compris le fond)
        const heroElements = document.querySelectorAll('.container-hero .logo, .container-hero .img-1, .container-hero .img-2, .container-hero .splash, .container-hero .splash-2, .container-hero .sentence, .container-hero .bg-hero');
        heroElements.forEach(el => {
            el.style.opacity = '0';
        });
        
        // Calculer le scale nécessaire pour remplir l'écran
        const imgRect = gifImg.getBoundingClientRect();
        const scaleToFillX = window.innerWidth / imgRect.width;
        const scaleToFillY = window.innerHeight / imgRect.height;
        const maxScale = Math.max(scaleToFillX, scaleToFillY) * 1.2; // 20% de plus pour dépasser
        
        // Après 4 secondes, lancer l'animation
        setTimeout(() => {
            let startTime = null;
            const duration = 1200; // 1.2 secondes
            
            function animate(currentTime) {
                if (!startTime) startTime = currentTime;
                const elapsed = currentTime - startTime;
                const progress = Math.min(elapsed / duration, 1);
                
                // Ease-in cubic pour l'accélération
                const eased = progress * progress * progress;
                
                // Zoom de 1 jusqu'à remplir l'écran
                const scale = 1 + eased * (maxScale - 1);
                
                // Distorsion linéaire (étirement horizontal qui augmente)
                const scaleX = scale * (1 + eased * 0.3);
                const scaleY = scale * (1 - eased * 0.1);
                
                // Opacité qui diminue
                const opacity = 1 - eased;
                
                // Léger flou qui augmente
                const blur = eased * 15;
                
                containerGif.style.transform = `translate(-50%, -50%) scale(${scaleX}, ${scaleY})`;
                containerGif.style.opacity = opacity;
                containerGif.style.filter = `blur(${blur}px)`;
                
                if (progress < 1) {
                    requestAnimationFrame(animate);
                } else {
                    loader.style.display = 'none';
                    // Forcer le scroll à 0
                    window.scrollTo(0, 0);
                    // Débloquer le scroll
                    document.body.style.overflow = '';
                    document.documentElement.style.overflow = '';
                    // Déclencher les animations d'entrée du hero
                    animateHeroEntrance();
                }
            }
            
            requestAnimationFrame(animate);
        }, 4000);
    }
    
    // Fonction pour animer l'entrée des éléments du hero
    function animateHeroEntrance() {
        const bgHero = document.querySelector('.container-hero .bg-hero');
        const logo = document.querySelector('.container-hero .logo');
        const img1 = document.querySelector('.container-hero .img-1');
        const img2 = document.querySelector('.container-hero .img-2');
        const splash = document.querySelector('.container-hero .splash');
        const splash2 = document.querySelector('.container-hero .splash-2');
        const sentence = document.querySelector('.container-hero .sentence');
        
        // Fond : le canvas WebGL apparaîtra directement (pas l'image)
        // On déclenche l'initialisation du WebGL maintenant
        initBgHeroWebGL();
        
        // Fonction d'animation pour un élément
        function animateElement(element, delay, fromY, fromScale, duration = 1000) {
            if (!element) return;
            
            element.style.opacity = '0';
            element.style.transform += ' translateY(' + fromY + 'px) scale(' + fromScale + ')';
            
            setTimeout(() => {
                element.style.transition = `opacity ${duration}ms ease-out, transform ${duration}ms ease-out`;
                element.style.opacity = '1';
                
                // Récupérer le transform original
                const originalTransform = element.dataset.originalTransform || '';
                element.style.transform = originalTransform;
            }, delay);
        }
        
        // Sauvegarder les transforms originaux
        if (logo) logo.dataset.originalTransform = 'translate(-50%, -50%)';
        if (img1) img1.dataset.originalTransform = '';
        if (img2) img2.dataset.originalTransform = '';
        if (splash) splash.dataset.originalTransform = '';
        if (splash2) splash2.dataset.originalTransform = '';
        if (sentence) sentence.dataset.originalTransform = '';
        
        // Cacher les éléments initialement
        [logo, img1, img2, splash, splash2, sentence].forEach(el => {
            if (el) {
                el.style.opacity = '0';
            }
        });
        
        // Animer chaque élément avec un délai différent
        // Logo : arrive par le bas avec overflow hidden
        if (logo) {
            // Créer un wrapper avec overflow hidden
            const wrapper = document.createElement('div');
            wrapper.style.cssText = `
                position: absolute;
                top: 50vh;
                left: 50%;
                transform: translate(-50%, -50%);
                width: 65%;
                overflow: hidden;
                z-index: 5;
            `;
            
            // Déplacer le logo dans le wrapper
            logo.parentNode.insertBefore(wrapper, logo);
            wrapper.appendChild(logo);
            
            // Repositionner le logo dans le wrapper
            logo.style.position = 'relative';
            logo.style.top = 'auto';
            logo.style.left = 'auto';
            logo.style.transform = 'translateY(100%)';
            logo.style.width = '100%';
            logo.style.opacity = '1';
            
            // Animer l'entrée
            setTimeout(() => {
                logo.style.transition = 'transform 1s cubic-bezier(0.16, 1, 0.3, 1)';
                logo.style.transform = 'translateY(0)';
            }, 100);
        }
        
        // img-1 : arrive de la droite
        if (img1) {
            img1.style.transform = 'translateX(100px)';
            setTimeout(() => {
                img1.style.transition = 'opacity 700ms ease-out, transform 700ms ease-out';
                img1.style.opacity = '1';
                img1.style.transform = 'translateX(0)';
            }, 300);
        }
        
        // img-2 : arrive de la droite avec délai
        if (img2) {
            img2.style.transform = 'translateX(100px)';
            setTimeout(() => {
                img2.style.transition = 'opacity 700ms ease-out, transform 700ms ease-out';
                img2.style.opacity = '1';
                img2.style.transform = 'translateX(0)';
            }, 500);
        }
        
        // splash : pas d'animation, juste afficher
        if (splash) {
            splash.style.opacity = '1';
        }
        
        // splash-2 : pas d'animation, juste afficher
        if (splash2) {
            splash2.style.opacity = '1';
        }
        
        // sentence : arrive du bas
        if (sentence) {
            sentence.style.transform = 'translateY(30px)';
            setTimeout(() => {
                sentence.style.transition = 'opacity 800ms ease-out, transform 800ms ease-out';
                sentence.style.opacity = '1';
                sentence.style.transform = 'translateY(0)';
            }, 700);
        }
    }
    
    // Animation verre flou (glassmorphism) pour le logo
    function animateLogoGlitch(logo) {
        if (typeof THREE === 'undefined') {
            logo.style.opacity = '1';
            logo.style.transform = 'translate(-50%, -50%)';
            return;
        }
        
        const logoRect = logo.getBoundingClientRect();
        
        const canvas = document.createElement('canvas');
        canvas.style.cssText = `
            position: absolute;
            top: 50vh;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 65%;
            height: auto;
            aspect-ratio: ${logoRect.width} / ${logoRect.height};
            z-index: 5;
            pointer-events: none;
        `;
        logo.parentNode.appendChild(canvas);
        
        const scene = new THREE.Scene();
        const camera = new THREE.OrthographicCamera(-1, 1, 1, -1, 0, 1);
        const renderer = new THREE.WebGLRenderer({ canvas, alpha: true, antialias: true });
        renderer.setSize(logoRect.width, logoRect.height);
        renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
        
        const texture = new THREE.TextureLoader().load(logo.src, () => {
            texture.minFilter = THREE.LinearFilter;
            texture.magFilter = THREE.LinearFilter;
        });
        
        const material = new THREE.ShaderMaterial({
            uniforms: {
                uTexture: { value: texture },
                uTime: { value: 0 },
                uProgress: { value: 0 },
                uResolution: { value: new THREE.Vector2(logoRect.width, logoRect.height) }
            },
            vertexShader: `
                varying vec2 vUv;
                void main() {
                    vUv = uv;
                    gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
                }
            `,
            fragmentShader: `
                uniform sampler2D uTexture;
                uniform float uTime;
                uniform float uProgress;
                uniform vec2 uResolution;
                varying vec2 vUv;
                
                void main() {
                    vec2 uv = vUv;
                    
                    // Intensité du flou qui diminue avec le progress
                    float blur = (1.0 - uProgress) * 0.012;
                    
                    // Blur gaussien circulaire (pas de bandes)
                    vec4 color = vec4(0.0);
                    float total = 0.0;
                    const float samples = 16.0;
                    
                    for(float i = 0.0; i < samples; i++) {
                        float angle = i * 6.28318 / samples;
                        for(float r = 1.0; r <= 3.0; r++) {
                            vec2 offset = vec2(cos(angle), sin(angle)) * r * blur;
                            float weight = 1.0 / r;
                            color += texture2D(uTexture, uv + offset) * weight;
                            total += weight;
                        }
                    }
                    // Ajouter le pixel central
                    color += texture2D(uTexture, uv) * 3.0;
                    total += 3.0;
                    color /= total;
                    
                    // Opacité progressive
                    float opacity = smoothstep(0.0, 0.6, uProgress);
                    
                    // Légère lueur pendant la transition
                    float glow = (1.0 - uProgress) * 0.05;
                    color.rgb += glow;
                    
                    gl_FragColor = vec4(color.rgb, color.a * opacity);
                }
            `,
            transparent: true
        });
        
        const geometry = new THREE.PlaneGeometry(2, 2);
        const mesh = new THREE.Mesh(geometry, material);
        scene.add(mesh);
        
        let startTime = null;
        const duration = 1500;
        
        function animate(currentTime) {
            if (!startTime) startTime = currentTime;
            const elapsed = currentTime - startTime;
            const progress = Math.min(elapsed / duration, 1);
            
            // Ease out cubic pour une révélation douce
            const easedProgress = 1 - Math.pow(1 - progress, 3);
            
            material.uniforms.uTime.value = elapsed * 0.001;
            material.uniforms.uProgress.value = easedProgress;
            
            // Scale du canvas pour l'effet d'expansion (subtil)
            const scale = 1 + (1 - easedProgress) * 0.03;
            canvas.style.transform = `translate(-50%, -50%) scale(${scale})`;
            
            renderer.render(scene, camera);
            
            if (progress < 1) {
                requestAnimationFrame(animate);
            } else {
                canvas.remove();
                logo.style.opacity = '1';
                logo.style.transform = 'translate(-50%, -50%)';
            }
        }
        
        setTimeout(() => {
            requestAnimationFrame(animate);
        }, 100);
    }

    // Fonction pour l'effet de grain animé (WebGL)
    function initGrainOverlay() {
        if (typeof THREE === 'undefined') {
            setTimeout(initGrainOverlay, 200);
            return;
        }
        
        const grainCanvas = document.createElement('canvas');
        grainCanvas.id = 'grain-overlay';
        grainCanvas.style.cssText = `
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            pointer-events: none;
            z-index: 9999;
            mix-blend-mode: multiply;
        `;
        document.body.appendChild(grainCanvas);
        
        const scene = new THREE.Scene();
        const camera = new THREE.OrthographicCamera(-1, 1, 1, -1, 0, 1);
        
        const renderer = new THREE.WebGLRenderer({
            canvas: grainCanvas,
            alpha: true,
            antialias: false,
            premultipliedAlpha: false
        });
        renderer.setSize(window.innerWidth, window.innerHeight);
        renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
        
        const grainShader = {
            uniforms: {
                uSeed: { value: Math.random() * 1000 },
                uResolution: { value: new THREE.Vector2(window.innerWidth, window.innerHeight) }
            },
            vertexShader: `
                void main() {
                    gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
                }
            `,
            fragmentShader: `
                uniform float uSeed;
                uniform vec2 uResolution;
                
                // Hash function pour bruit de qualité
                float hash(vec2 p, float seed) {
                    vec3 p3 = fract(vec3(p.xyx) * 0.1031);
                    p3 += dot(p3, p3.yzx + 33.33 + seed);
                    return fract((p3.x + p3.y) * p3.z);
                }
                
                void main() {
                    vec2 pixelCoord = gl_FragCoord.xy;
                    
                    // Grain principal
                    float grain = hash(pixelCoord, uSeed);
                    
                    // Grain secondaire plus gros pour variation
                    float grain2 = hash(pixelCoord * 0.5, uSeed * 1.5);
                    
                    // Mélanger les deux grains
                    float mixedGrain = grain * 0.7 + grain2 * 0.3;
                    
                    // Valeurs entre 0.8 et 1.0
                    mixedGrain = mixedGrain * 0.2 + 0.8;
                    
                    // Teinte vintage légèrement chaude
                    vec3 vintageColor;
                    vintageColor.r = mixedGrain;
                    vintageColor.g = mixedGrain * 0.98;
                    vintageColor.b = mixedGrain * 0.94;
                    
                    // Légères rayures verticales aléatoires (effet pellicule)
                    float scratch = hash(vec2(pixelCoord.x * 0.01, uSeed), uSeed);
                    if (scratch > 0.997) {
                        vintageColor *= 0.7;
                    }
                    
                    gl_FragColor = vec4(vintageColor, 1.0);
                }
            `
        };
        
        const material = new THREE.ShaderMaterial({
            uniforms: grainShader.uniforms,
            vertexShader: grainShader.vertexShader,
            fragmentShader: grainShader.fragmentShader,
            transparent: true,
            depthTest: false,
            depthWrite: false
        });
        
        const geometry = new THREE.PlaneGeometry(2, 2);
        const mesh = new THREE.Mesh(geometry, material);
        scene.add(mesh);
        
        window.addEventListener('resize', () => {
            renderer.setSize(window.innerWidth, window.innerHeight);
            material.uniforms.uResolution.value.set(window.innerWidth, window.innerHeight);
        });
        
        // Animation : nouveau seed à chaque frame pour scintillement
        let lastFrame = 0;
        const fps = 8;
        const frameInterval = 1000 / fps;
        
        function animate(currentTime) {
            requestAnimationFrame(animate);
            
            if (currentTime - lastFrame > frameInterval) {
                lastFrame = currentTime;
                // Nouveau seed aléatoire = nouveau pattern de grain
                material.uniforms.uSeed.value = Math.random() * 1000;
                renderer.render(scene, camera);
            }
        }
        
        requestAnimationFrame(animate);
    }

    // Fonction pour changer l'image de fond entre bio et events avec morphing WebGL
    function initBgImageSwitch() {
        if (typeof THREE === 'undefined') {
            setTimeout(initBgImageSwitch, 100);
            return;
        }
        
        const imgBg = document.querySelector('.container-bio-events .img-bg');
        const sectionEvents = document.querySelector('.section-events');
        const containerBioEvents = document.querySelector('.container-bio-events');
        
        if (!imgBg || !sectionEvents || !containerBioEvents) {
            return;
        }
        
        // URLs des images
        const bioSrc = imgBg.src;
        const eventSrc = bioSrc.replace('bg-bio.jpg', 'bg-event.jpg');
        
        // Créer le canvas WebGL
        const canvas = document.createElement('canvas');
        canvas.style.cssText = `
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            z-index: 0;
            pointer-events: none;
        `;
        
        imgBg.parentNode.insertBefore(canvas, imgBg);
        imgBg.style.display = 'none';
        
        // Variables Three.js
        let scene, camera, renderer, material;
        let morphProgress = 0;
        let targetProgress = 0;
        let currentPosition = 'absolute';
        
        // Charger les textures
        const textureLoader = new THREE.TextureLoader();
        
        Promise.all([
            new Promise(resolve => textureLoader.load(bioSrc, resolve)),
            new Promise(resolve => textureLoader.load(eventSrc, resolve))
        ]).then(([textureBio, textureEvent]) => {
            // Scène
            scene = new THREE.Scene();
            camera = new THREE.OrthographicCamera(-1, 1, 1, -1, 0, 1);
            
            renderer = new THREE.WebGLRenderer({
                canvas: canvas,
                alpha: false,
                antialias: false
            });
            
            // Shader de morphing avec effet de flottement comme le hero
            material = new THREE.ShaderMaterial({
                uniforms: {
                    uTexture1: { value: textureBio },
                    uTexture2: { value: textureEvent },
                    uProgress: { value: 0.0 },
                    uTime: { value: 0.0 },
                    uIntensity: { value: 0.3 },
                    uCoverScale: { value: new THREE.Vector2(1, 1) }
                },
                vertexShader: `
                    varying vec2 vUv;
                    void main() {
                        vUv = uv;
                        gl_Position = vec4(position, 1.0);
                    }
                `,
                fragmentShader: `
                    uniform sampler2D uTexture1;
                    uniform sampler2D uTexture2;
                    uniform float uProgress;
                    uniform float uTime;
                    uniform float uIntensity;
                    uniform vec2 uCoverScale;
                    varying vec2 vUv;
                    
                    void main() {
                        // Appliquer le scale "cover" pour éviter l'étirement
                        vec2 uv = (vUv - 0.5) / uCoverScale + 0.5;
                        
                        // Zoom léger pour éviter les bords visibles pendant le flottement
                        float zoom = 0.94;
                        uv = (uv - 0.5) * zoom + 0.5;
                        
                        // Flottement global de l'image entière (comme le hero)
                        float floatX = sin(uTime * 0.4) * 0.018;
                        float floatY = cos(uTime * 0.3) * 0.014;
                        float floatDiag = sin(uTime * 0.25) * 0.01;
                        
                        uv.x += floatX + floatDiag;
                        uv.y += floatY + floatDiag * 0.6;
                        
                        // Distorsion ondulante (vagues visibles)
                        float wave1 = sin(uv.x * 4.0 + uTime * 0.5) * 0.006;
                        float wave2 = cos(uv.y * 3.0 + uTime * 0.4) * 0.006;
                        float wave3 = sin(uv.x * 2.0 + uv.y * 2.5 + uTime * 0.6) * 0.004;
                        
                        // Mouvement circulaire
                        float dist = distance(uv, vec2(0.5, 0.5));
                        float circularWave = sin(dist * 5.0 - uTime * 0.3) * 0.005;
                        
                        // Appliquer la distorsion de flottement
                        uv.x += wave1 + wave3 + circularWave;
                        uv.y += wave2 + wave3 + circularWave * 0.7;
                        
                        // Effet de distorsion supplémentaire pendant la transition morphing
                        float morphDistortion = sin(uv.y * 10.0 + uTime * 2.0) * uIntensity * uProgress * (1.0 - uProgress) * 4.0;
                        morphDistortion += sin(uv.x * 8.0 - uTime * 1.5) * uIntensity * uProgress * (1.0 - uProgress) * 3.0;
                        
                        vec2 uv1 = uv + vec2(morphDistortion * 0.05, morphDistortion * 0.03);
                        vec2 uv2 = uv - vec2(morphDistortion * 0.05, morphDistortion * 0.03);
                        
                        vec4 color1 = texture2D(uTexture1, uv1);
                        vec4 color2 = texture2D(uTexture2, uv2);
                        
                        // Courbe de transition smooth
                        float smoothProgress = smoothstep(0.0, 1.0, uProgress);
                        
                        // Mix avec légère aberration chromatique pendant la transition
                        float aberration = uProgress * (1.0 - uProgress) * 0.02;
                        vec4 color1R = texture2D(uTexture1, uv1 + vec2(aberration, 0.0));
                        vec4 color2R = texture2D(uTexture2, uv2 + vec2(aberration, 0.0));
                        vec4 color1B = texture2D(uTexture1, uv1 - vec2(aberration, 0.0));
                        vec4 color2B = texture2D(uTexture2, uv2 - vec2(aberration, 0.0));
                        
                        vec4 finalColor1 = vec4(color1R.r, color1.g, color1B.b, color1.a);
                        vec4 finalColor2 = vec4(color2R.r, color2.g, color2B.b, color2.a);
                        
                        vec4 mixedColor = mix(finalColor1, finalColor2, smoothProgress);
                        
                        // Variation de luminosité (respiration) comme le hero
                        float breathe = 1.0 + sin(uTime * 0.2) * 0.035;
                        mixedColor.rgb *= breathe;
                        
                        gl_FragColor = mixedColor;
                        
                        // Opacité selon l'image (bio = 0.4, event = 0.8)
                        gl_FragColor.a = mix(0.4, 0.8, smoothProgress);
                    }
                `,
                transparent: true
            });
            
            const geometry = new THREE.PlaneGeometry(2, 2);
            const mesh = new THREE.Mesh(geometry, material);
            scene.add(mesh);
            
            // Taille du renderer - largeur 100%, hauteur selon le ratio ou 100vh sur mobile
            const imageAspect = textureBio.image.width / textureBio.image.height;
            
            function updateSize() {
                const width = window.innerWidth;
                const currentIsMobile = window.innerWidth <= 768;
                // Sur mobile : 100vh, sur desktop : ratio naturel de l'image
                const height = currentIsMobile ? window.innerHeight : width / imageAspect;
                const dpr = Math.min(window.devicePixelRatio, 2);
                canvas.style.width = width + 'px';
                canvas.style.height = height + 'px';
                renderer.setSize(width, height);
                renderer.setPixelRatio(dpr);
                
                // Calculer le scale pour l'effet "cover" sur mobile
                if (currentIsMobile && material) {
                    const screenAspect = width / height;
                    let scaleX = 1, scaleY = 1;
                    
                    if (screenAspect > imageAspect) {
                        // Écran plus large que l'image
                        scaleY = screenAspect / imageAspect;
                    } else {
                        // Écran plus haut que l'image
                        scaleX = imageAspect / screenAspect;
                    }
                    
                    material.uniforms.uCoverScale.value.set(scaleX, scaleY);
                } else if (material) {
                    material.uniforms.uCoverScale.value.set(1, 1);
                }
            }
            updateSize();
            window.addEventListener('resize', updateSize);
            
            // Animation
            let time = 0;
            function animate() {
                requestAnimationFrame(animate);
                
                time += 0.016;
                
                // Interpolation smooth vers la cible
                morphProgress += (targetProgress - morphProgress) * 0.08;
                
                material.uniforms.uProgress.value = morphProgress;
                material.uniforms.uTime.value = time;
                
                renderer.render(scene, camera);
            }
            animate();
        });
        
        // Gestion du scroll
        function handleScroll() {
            const containerRect = containerBioEvents.getBoundingClientRect();
            const eventsRect = sectionEvents.getBoundingClientRect();
            const windowHeight = window.innerHeight;
            const canvasHeight = canvas.offsetHeight;
            
            // Gérer la position fixed/absolute du canvas
            const containerTop = containerRect.top;
            const containerBottom = containerRect.bottom;
            
            // Calculer le point où le canvas doit se détacher (quand le bas du canvas atteint le bas du container)
            const detachPoint = containerBottom - canvasHeight;
            
            if (containerTop <= 0 && detachPoint > 0) {
                // Le canvas est visible et n'a pas encore atteint le bas
                if (currentPosition !== 'fixed') {
                    canvas.style.position = 'fixed';
                    canvas.style.top = '0';
                    canvas.style.left = '0';
                    canvas.style.bottom = 'auto';
                    currentPosition = 'fixed';
                }
            } else if (detachPoint <= 0 && containerBottom > 0) {
                // Le canvas a atteint le bas du container, le fixer en absolute
                if (currentPosition !== 'absolute-bottom') {
                    canvas.style.position = 'absolute';
                    canvas.style.top = (containerRect.height - canvasHeight) + 'px';
                    canvas.style.bottom = 'auto';
                    currentPosition = 'absolute-bottom';
                }
            } else {
                if (currentPosition !== 'absolute') {
                    canvas.style.position = 'absolute';
                    canvas.style.top = '0';
                    canvas.style.bottom = 'auto';
                    currentPosition = 'absolute';
                }
            }
            
            // Calculer la progression du morphing
            const triggerPoint = windowHeight * 0.5;
            
            if (eventsRect.top < triggerPoint) {
                targetProgress = 1.0;
            } else {
                targetProgress = 0.0;
            }
        }
        
        window.addEventListener('scroll', handleScroll, { passive: true });
        handleScroll();
    }

    // Fonction pour gérer l'effet WebGL du fond hero
    function initBgHeroWebGL() {
        // Vérifier que Three.js est chargé, sinon réessayer
        if (typeof THREE === 'undefined') {
            setTimeout(initBgHeroWebGL, 100);
            return;
        }
        
        const bgHeroImg = document.querySelector('.container-hero .bg-hero');
        
        if (!bgHeroImg) {
            console.warn('Image bg-hero non trouvée');
            return;
        }
        
        // Attendre que l'image soit chargée
        if (bgHeroImg.complete) {
            createBgHeroCanvas(bgHeroImg);
        } else {
            bgHeroImg.addEventListener('load', () => {
                createBgHeroCanvas(bgHeroImg);
            });
        }
    }
    
    // Variables globales pour l'effet bg-hero
    let bgHeroCanvas = null;
    let bgHeroScene = null;
    let bgHeroRenderer = null;
    let bgHeroMaterial = null;
    let bgHeroMesh = null;
    let bgHeroCamera = null;
    let bgHeroTexture = null;
    let bgHeroCurrentTime = 0;
    let bgHeroElement = null;
    
    function createBgHeroCanvas(imgElement) {
        // Vérifier que Three.js est chargé
        if (typeof THREE === 'undefined') {
            console.warn('Three.js non chargé pour bg-hero');
            return;
        }
        
        bgHeroElement = imgElement;
        
        // Créer le canvas
        bgHeroCanvas = document.createElement('canvas');
        bgHeroCanvas.className = 'bg-hero-webgl-canvas';
        bgHeroCanvas.style.position = 'absolute';
        bgHeroCanvas.style.top = '0';
        bgHeroCanvas.style.left = '0';
        bgHeroCanvas.style.width = '100%';
        bgHeroCanvas.style.height = 'auto';
        bgHeroCanvas.style.zIndex = '0';
        bgHeroCanvas.style.pointerEvents = 'none';
        bgHeroCanvas.style.opacity = '0';
        bgHeroCanvas.style.transition = 'opacity 800ms ease-out';
        
        // Insérer le canvas avant l'image et cacher l'image
        bgHeroElement.parentNode.insertBefore(bgHeroCanvas, bgHeroElement);
        bgHeroElement.style.display = 'none';
        
        // Initialiser Three.js puis faire apparaître le canvas
        initBgHeroThreeJS();
        
        // Fondu d'apparition après un court délai
        setTimeout(() => {
            bgHeroCanvas.style.opacity = '1';
        }, 100);
    }
    
    function initBgHeroThreeJS() {
        // Scène
        bgHeroScene = new THREE.Scene();
        
        // Caméra orthographique
        bgHeroCamera = new THREE.OrthographicCamera(-1, 1, 1, -1, 0, 1);
        
        // Renderer
        bgHeroRenderer = new THREE.WebGLRenderer({
            canvas: bgHeroCanvas,
            alpha: false,
            antialias: false,
            precision: 'highp'
        });
        
        // Taille basée sur l'image originale
        const updateBgHeroSize = () => {
            const containerHero = document.querySelector('.container-hero');
            if (!containerHero) return;
            
            const width = containerHero.offsetWidth;
            const height = bgHeroElement.naturalHeight * (width / bgHeroElement.naturalWidth);
            
            // Appliquer la hauteur au canvas
            bgHeroCanvas.style.height = height + 'px';
            bgHeroRenderer.setSize(width, height);
            bgHeroRenderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
            
            // Donner la même hauteur au container-hero
            containerHero.style.height = height + 'px';
        };
        
        updateBgHeroSize();
        window.addEventListener('resize', updateBgHeroSize);
        
        // Shader avec effet de flottement global
        const bgHeroShader = {
            uniforms: {
                uTexture: { value: null },
                uTime: { value: 0 }
            },
            vertexShader: `
                varying vec2 vUv;
                void main() {
                    vUv = uv;
                    gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
                }
            `,
            fragmentShader: `
                uniform sampler2D uTexture;
                uniform float uTime;
                varying vec2 vUv;
                
                void main() {
                    vec2 uv = vUv;
                    
                    // Zoom léger pour éviter les bords visibles pendant le flottement
                    float zoom = 0.94;
                    uv = (uv - 0.5) * zoom + 0.5;
                    
                    // Flottement global de l'image entière
                    float floatX = sin(uTime * 0.4) * 0.018;
                    float floatY = cos(uTime * 0.3) * 0.014;
                    float floatDiag = sin(uTime * 0.25) * 0.01;
                    
                    uv.x += floatX + floatDiag;
                    uv.y += floatY + floatDiag * 0.6;
                    
                    // Distorsion ondulante (vagues visibles)
                    float wave1 = sin(uv.x * 4.0 + uTime * 0.5) * 0.006;
                    float wave2 = cos(uv.y * 3.0 + uTime * 0.4) * 0.006;
                    float wave3 = sin(uv.x * 2.0 + uv.y * 2.5 + uTime * 0.6) * 0.004;
                    
                    // Mouvement circulaire
                    float dist = distance(uv, vec2(0.5, 0.5));
                    float circularWave = sin(dist * 5.0 - uTime * 0.3) * 0.005;
                    
                    // Appliquer la distorsion
                    uv.x += wave1 + wave3 + circularWave;
                    uv.y += wave2 + wave3 + circularWave * 0.7;
                    
                    // Échantillonner la texture
                    vec4 color = texture2D(uTexture, uv);
                    
                    // Variation de luminosité (respiration)
                    float breathe = 1.0 + sin(uTime * 0.2) * 0.035;
                    color.rgb *= breathe;
                    
                    gl_FragColor = color;
                }
            `
        };
        
        // Matériau avec shader
        bgHeroMaterial = new THREE.ShaderMaterial(bgHeroShader);
        
        // Géométrie plane
        const geometry = new THREE.PlaneGeometry(2, 2);
        bgHeroMesh = new THREE.Mesh(geometry, bgHeroMaterial);
        bgHeroScene.add(bgHeroMesh);
        
        // Charger la texture
        loadBgHeroTexture();
        
        // Démarrer l'animation
        animateBgHeroThreeJS();
    }
    
    function loadBgHeroTexture() {
        if (!bgHeroElement) return;
        
        const imageSrc = bgHeroElement.src;
        const loader = new THREE.TextureLoader();
        
        loader.load(
            imageSrc,
            (texture) => {
                texture.wrapS = THREE.ClampToEdgeWrapping;
                texture.wrapT = THREE.ClampToEdgeWrapping;
                texture.minFilter = THREE.LinearFilter;
                texture.magFilter = THREE.LinearFilter;
                texture.generateMipmaps = false;
                texture.flipY = true;
                texture.needsUpdate = true;
                
                bgHeroTexture = texture;
                bgHeroMaterial.uniforms.uTexture.value = bgHeroTexture;
            },
            undefined,
            (error) => {
                console.error('Erreur chargement texture bg-hero:', error);
                // Fallback : montrer l'image originale
                if (bgHeroElement) {
                    bgHeroElement.style.display = '';
                }
                if (bgHeroCanvas && bgHeroCanvas.parentNode) {
                    bgHeroCanvas.parentNode.removeChild(bgHeroCanvas);
                    bgHeroCanvas = null;
                }
            }
        );
    }
    
    function animateBgHeroThreeJS() {
        if (!bgHeroRenderer || !bgHeroScene || !bgHeroCamera) return;
        
        bgHeroCurrentTime += 0.016; // ~60fps
        
        // Mettre à jour le temps du shader
        if (bgHeroMaterial && bgHeroMaterial.uniforms && bgHeroMaterial.uniforms.uTime) {
            bgHeroMaterial.uniforms.uTime.value = bgHeroCurrentTime;
        }
        
        // Render
        bgHeroRenderer.render(bgHeroScene, bgHeroCamera);
        
        // Continuer l'animation
        requestAnimationFrame(animateBgHeroThreeJS);
    }

    // Initialisation des nouvelles fonctionnalités
    thresholder();
    reline(); // Initialiser $lines dès le début
    initCasesList(); // Initialiser la liste cases
    initProjectImageHover(); // Initialiser les images de projet
    initHeaderScroll(); // Initialiser l'effet scroll du header
    initSmoothScroll(); // Initialiser le smooth scroll pour les liens d'ancrage
    initHeroParallax(); // Initialiser l'effet parallax du hero
    initBioParallax(); // Initialiser l'effet parallax de img-bio
    initSoundSentenceScroll(); // Initialiser le défilement de la sentence sound
    initContactParallax(); // Initialiser le parallax sur contact title-img
    initTextIntroTyping(); // Initialiser l'effet d'écriture sur text-intro
    initBgImageSwitch(); // Initialiser le changement d'image de fond bio/events
    initGrainOverlay(); // Initialiser l'effet de grain animé
    initLoaderAnimation(); // Initialiser l'animation du loader
    
    // L'effet WebGL du fond hero est initialisé dans animateHeroEntrance()
    
    // Initialiser l'effet WebGL pour l'image .wave après un délai pour s'assurer que l'image est chargée
    setTimeout(() => {
        // Vérifier que l'image existe avant de créer l'effet WebGL
        const waveImg = document.querySelector('.wave');
        if (waveImg && waveImg.complete) {
            createWaveCanvas();
        } else if (waveImg) {
            // Attendre que l'image soit chargée
            waveImg.addEventListener('load', () => {
                createWaveCanvas();
            });
            // Fallback après 3 secondes
            setTimeout(() => {
                if (waveImg && waveImg.style.display === 'none') {
                    waveImg.style.display = '';
                }
            }, 3000);
        }
    }, 100);
    
    // Gérer le redimensionnement pour l'effet wave
    window.addEventListener('resize', handleWaveResize);
    
});

// === SMOOTH SCROLL POUR LES LIENS D'ANCRAGE ===

function initSmoothScroll() {
    // Récupérer tous les liens qui pointent vers des ancres
    const anchorLinks = document.querySelectorAll('a[href^="#"]');
    
    anchorLinks.forEach(link => {
        link.addEventListener('click', function(e) {
            e.preventDefault();
            
            const targetId = this.getAttribute('href');
            const targetElement = document.querySelector(targetId);
            
            if (targetElement) {
                smoothScrollToElement(targetElement);
            }
        });
    });
}

function smoothScrollToElement(element) {
    const elementRect = element.getBoundingClientRect();
    const elementTop = elementRect.top + window.scrollY;
    const startPosition = window.scrollY;
    const distance = elementTop - startPosition;
    const duration = 1500; // 1.5 secondes
    let startTime = null;
    
    function easeInOutQuart(t) {
        return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * (--t) * t * t * t;
    }
    
    function animation(currentTime) {
        if (startTime === null) startTime = currentTime;
        const timeElapsed = currentTime - startTime;
        const progress = Math.min(timeElapsed / duration, 1);
        
        // Appliquer l'easing
        const ease = easeInOutQuart(progress);
        
        // Calculer la position actuelle
        const currentPosition = startPosition + (distance * ease);
        
        // Défiler vers la position
        window.scrollTo(0, currentPosition);
        
        // Continuer l'animation si pas terminée
        if (progress < 1) {
            requestAnimationFrame(animation);
        }
    }
    
    requestAnimationFrame(animation);
}

// Animation SVG dans la div "cases"
let lastScrollY = 0;
let ticking = false;

function handleSVGAnimation() {
    const casesDiv = document.querySelector('.cases');
    const svg = casesDiv ? casesDiv.querySelector('svg') : null;
    
    if (!casesDiv || !svg) return;
    
    const svgRect = svg.getBoundingClientRect();
    const windowHeight = window.innerHeight;
    
    // Calculer la position du SVG par rapport au viewport
    const svgTop = svgRect.top;
    const svgHeight = svgRect.height;

    // Calculer la progression de manière plus simple et continue
    let progress = 0;
    
    // Si le SVG est complètement au-dessus du viewport
    if (svgTop + svgHeight < 0) {
        progress = 1;
    }
    // Si le SVG est complètement en-dessous du viewport
    else if (svgTop > windowHeight) {
        progress = 0;
    }
    // Si le SVG est partiellement ou complètement visible
    else {
        // Calculer le pourcentage de défilement à travers le SVG
        const scrollProgress = (windowHeight - svgTop) / (windowHeight + svgHeight);
        progress = Math.max(0, Math.min(1, scrollProgress));
    }
    
    // Fonction d'easing pour adoucir l'animation
    const easeOutQuart = (t) => 1 - Math.pow(1 - t, 4);
    const smoothProgress = easeOutQuart(progress);
    
    // Appliquer la transformation scaleY
    const scaleY = Math.max(0, Math.min(1, smoothProgress));
    svg.style.transform = `scaleY(${scaleY})`;
    svg.style.transformOrigin = 'top';
    svg.style.transition = 'none';
    
    ticking = false;
}

function requestSVGAnimation() {
    if (!ticking) {
        requestAnimationFrame(handleSVGAnimation);
        ticking = true;
    }
}

// Ajouter l'animation SVG au scroll
window.addEventListener('scroll', requestSVGAnimation);
window.addEventListener('resize', requestSVGAnimation);

// Initialiser l'animation SVG
document.addEventListener('DOMContentLoaded', function() {
    const svg = document.querySelector('.cases svg');
    if (svg) {
        svg.style.transform = 'scaleY(0)';
        svg.style.transformOrigin = 'top';
    }
    handleSVGAnimation();
});

// === ANIMATION SCROLL HORIZONTAL POUR LES CARDS PROCESS ===

let processCardsWrapper = null;
let processCards = [];
let processContainer = null;
let processSection = null;
let scrollSpacer = null;
let sectionOriginalTop = 0;

function initProcessCards() {
    processSection = document.querySelector('.process');
    processContainer = document.querySelector('.process-cards-container');
    processCardsWrapper = document.querySelector('.process-cards-wrapper');
    
    if (processCardsWrapper && processSection) {
        processCards = Array.from(processCardsWrapper.querySelectorAll('.process-card'));
        
        // Vérifier si on est sur mobile
        const isMobile = window.innerWidth <= 768;
        
        if (!isMobile) {
            // Stocker la position originale de la section (remettre en mode normal d'abord)
            processSection.style.position = 'relative';
            processSection.style.top = 'auto';
            processSection.style.zIndex = 'auto';
            
            // Forcer un reflow pour obtenir la vraie position
            processSection.getBoundingClientRect();
            sectionOriginalTop = processSection.getBoundingClientRect().top + window.scrollY;
            
            // Créer un spacer invisible après la section pour permettre le scroll
            if (!scrollSpacer) {
                scrollSpacer = document.createElement('div');
                scrollSpacer.className = 'process-scroll-spacer';
                scrollSpacer.style.height = window.innerHeight * 4 + 'px'; // Augmenter pour plus de transition
                scrollSpacer.style.width = '100%';
                scrollSpacer.style.pointerEvents = 'none';
                
                // Insérer le spacer après la section process
                processSection.parentNode.insertBefore(scrollSpacer, processSection.nextSibling);
            }
        } else {
            // Sur mobile, supprimer le spacer s'il existe
            if (scrollSpacer && scrollSpacer.parentNode) {
                scrollSpacer.parentNode.removeChild(scrollSpacer);
                scrollSpacer = null;
            }
        }
        
        // console.log('Process cards initialized:', processCards.length, 'Section original top:', sectionOriginalTop);
    }
}

function animateProcessCards() {
    if (!processSection || !processContainer || !processCardsWrapper || processCards.length === 0) return;
    
    // Désactiver l'animation de scroll sur mobile
    const isMobile = window.innerWidth <= 768;
    if (isMobile) {
        // Réinitialiser les styles pour mobile
        processSection.style.position = 'relative';
        processSection.style.top = 'auto';
        processSection.style.zIndex = 'auto';
        processSection.style.width = 'auto';
        processSection.style.opacity = '1';
        processSection.style.pointerEvents = 'auto';
        processCardsWrapper.style.transform = 'translateX(0px)';
        
        // Réinitialiser les styles des cartes
        processCards.forEach((card) => {
            card.style.opacity = '1';
            card.style.transform = 'scale(1)';
        });
        
        // Sur mobile, appliquer la classe "end" au body quand on dépasse la section process
        const processRect = processSection.getBoundingClientRect();
        const windowHeight = window.innerHeight;
        
        if (processRect.bottom < 0) {
            // La section process est dépassée, on applique la classe "end"
            document.body.classList.add('end');
        } else {
            // La section process est encore visible, on retire la classe "end"
            document.body.classList.remove('end');
        }
        
        return; // Sortir de la fonction sur mobile
    }
    
    // Enlever la transition automatique pour contrôler manuellement
    processSection.style.transition = 'none';
    
    const currentScrollY = window.scrollY;
    
    // Calculer si on est dans la zone de scroll basé sur la position de scroll
    const scrollIntoSection = currentScrollY - sectionOriginalTop;
    const spacerHeight = scrollSpacer ? parseFloat(scrollSpacer.style.height) : 0;
    
    // Diviser la zone de scroll en deux parties
    const cardScrollZone = spacerHeight * 0.6; // 60% pour le scroll des cards
    const fadeZone = spacerHeight * 0.4; // 40% pour la transition d'opacité
    
    let scrollProgress = 0;
    let fadeProgress = 0;
    let isInScrollZone = false;
    
    if (scrollIntoSection < 0) {
        // Avant la zone de scroll - position normale
        processSection.style.position = 'relative';
        processSection.style.top = 'auto';
        processSection.style.zIndex = 'auto';
        processSection.style.width = 'auto';
        processSection.style.opacity = '1';
        processSection.style.pointerEvents = 'auto';
        scrollProgress = 0;
        fadeProgress = 0;
        isInScrollZone = false;
        
        // Retirer la classe "end" du body si on remonte
        document.body.classList.remove('end');
    } else if (scrollIntoSection >= 0 && scrollIntoSection <= spacerHeight) {
        // Dans la zone de scroll - position sticky
        isInScrollZone = true;
        
        // Appliquer sticky à la section
        processSection.style.position = 'sticky';
        processSection.style.top = '0';
        processSection.style.zIndex = '10';
        processSection.style.width = '100%';
        processSection.style.pointerEvents = 'auto';
        
        // Retirer la classe "end" du body pendant le scroll
        document.body.classList.remove('end');
        
        if (scrollIntoSection <= cardScrollZone) {
            // Zone de scroll des cards (60% du début)
            scrollProgress = scrollIntoSection / cardScrollZone;
            scrollProgress = Math.max(0, Math.min(1, scrollProgress));
            fadeProgress = 0;
            processSection.style.opacity = '1';
        } else {
            // Zone de transition d'opacité (40% de la fin)
            scrollProgress = 1; // Cards restent en position finale
            const fadeScrollDistance = scrollIntoSection - cardScrollZone;
            fadeProgress = fadeScrollDistance / fadeZone;
            fadeProgress = Math.max(0, Math.min(1, fadeProgress));
            
            // Calculer l'opacité (de 1 à 0)
            const opacity = 1 - fadeProgress;
            processSection.style.opacity = opacity.toString();
        }
    } else {
        // Après la zone de scroll - complètement invisible
        processSection.style.position = 'relative';
        processSection.style.top = 'auto';
        processSection.style.zIndex = 'auto';
        processSection.style.width = 'auto';
        processSection.style.opacity = '0';
        processSection.style.pointerEvents = 'none';
        scrollProgress = 1;
        fadeProgress = 1;
        isInScrollZone = false;
        
        // Ajouter la classe "end" au body quand la section a complètement disparu
        document.body.classList.add('end');
    }
    
    // Calculer et appliquer le scroll horizontal
    if (scrollProgress > 0) {
        const viewportWidth = window.innerWidth;
        const cardWidth = viewportWidth * 0.35;
        const gap = 32;
        const lastCardMargin = viewportWidth * 0.08; // 8vw de marge pour la dernière card
        
        const totalCardsWidth = (cardWidth * processCards.length) + (gap * (processCards.length - 1)) + lastCardMargin;
        const containerWidth = processContainer.clientWidth;
        
        // Calculer le décalage pour que la première card soit visible
        const maxScrollDistance = Math.max(0, totalCardsWidth - containerWidth);
        
        // Démarrer le scroll depuis une position qui montre bien la première card
        const startOffset = Math.min(cardWidth * 0.1, 50); // Petit décalage pour voir la première card
        const scrollDistance = startOffset + (scrollProgress * maxScrollDistance);
        processCardsWrapper.style.transform = `translateX(-${scrollDistance}px)`;
    } else {
        processCardsWrapper.style.transform = 'translateX(0px)';
    }
    
    // Effet sur les cards
    processCards.forEach((card, index) => {
        const cardStartProgress = index / processCards.length;
        const cardEndProgress = (index + 1) / processCards.length;
        
        let cardProgress = 0;
        if (scrollProgress >= cardStartProgress && scrollProgress <= cardEndProgress) {
            cardProgress = (scrollProgress - cardStartProgress) / (cardEndProgress - cardStartProgress);
        } else if (scrollProgress > cardEndProgress) {
            cardProgress = 1;
        }
        
        const opacity = Math.max(0.4, 0.4 + (cardProgress * 0.6));
        const scale = 0.95 + (cardProgress * 0.05);
        
        card.style.opacity = opacity;
        card.style.transform = `scale(${scale})`;
    });
}

// Fonction optimisée pour les performances
let processAnimationFrame = null;

function requestProcessAnimation() {
    if (processAnimationFrame) return;
    
    processAnimationFrame = requestAnimationFrame(() => {
        animateProcessCards();
        processAnimationFrame = null;
    });
}

// Initialiser au chargement de la page
document.addEventListener('DOMContentLoaded', function() {
    setTimeout(() => {
        initProcessCards();
        animateProcessCards();
        
        // Recalculer la position après application des styles
        setTimeout(() => {
            if (processSection) {
                processSection.style.position = 'relative';
                processSection.style.top = 'auto';
                processSection.style.zIndex = 'auto';
                processSection.getBoundingClientRect();
                sectionOriginalTop = processSection.getBoundingClientRect().top + window.scrollY;
                // console.log('Position recalculée:', sectionOriginalTop);
            }
        }, 200);
    }, 100);
});

// Ajouter les événements
window.addEventListener('scroll', requestProcessAnimation);
window.addEventListener('resize', () => {
    // Réinitialiser complètement lors du redimensionnement
    initProcessCards();
    requestProcessAnimation();
});

Rgpd(cat => {
    console.log(`cookies ${cat} enabled`);
    if (cat === 'statistiques') {
        /* (function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
        (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
        m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
        })(window,document,'script','https://www.google-analytics.com/analytics.js','ga');
        ga('create', ParamsData.gtag_key, 'auto');
        ga('send', 'pageview'); */
    }
});

document.documentElement.className = 'js';

conditioner.addPlugin({
    // the plugin "monitor" hook
    // use in html : <div data-module="modules/component.js" data-context="@visible true"></div>
    monitor: {
    // the name of our monitor, not prefixed with "@"
        name: 'visible',

        // the monitor factory method, this will create our monitor
        create: (context, element) => ({
            // current match state
            matches: false,

            // called by conditioner to start listening for changes
            addListener(change) {
                new IntersectionObserver((entries) => {
                    // update the matches state
                    this.matches = entries.pop().isIntersecting === context;

                    // inform conditioner of the new state
                    change();
                }).observe(element);
            },
        }),
    },

    // converts module aliases to paths
    moduleSetName: (name) => `./modules/${name}.js`,

    // get the module constructor
    moduleGetConstructor: (module) => module.default,

    // override the import (this makes webpack bundle all the dynamically included files as well)
    // https://webpack.js.org/api/module-methods/#import-
    // - set to "eager" to create a single chunk for all modules
    // - set to "lazy" to create a separate chunk for each module
    moduleImport: (name) => import(/* webpackMode: "lazy" */ `${name}`),
});

conditioner.hydrate(document.documentElement);

    // Gestion de l'effet WebGL pour l'image .wave
    let waveCanvas = null;
    let waveScene = null;
    let waveRenderer = null;
    let waveMaterial = null;
    let waveMesh = null;
    let waveCamera = null;
    let waveTexture = null;
    let waveCurrentTime = 0;
    let waveElement = null;

    function createWaveCanvas() {
        // Désactiver sur très petits écrans pour les performances
        if (window.innerWidth <= 575) {
            // S'assurer que l'image originale est visible sur petits écrans
            waveElement = document.querySelector('.wave');
            if (waveElement) {
                waveElement.style.display = '';
            }
            return;
        }
        
        waveElement = document.querySelector('.wave');
        if (!waveElement) return;
        
        // Créer le canvas
        waveCanvas = document.createElement('canvas');
        waveCanvas.className = 'wave-webgl-canvas';
        
        // Copier les styles de l'image originale
        const computedStyle = window.getComputedStyle(waveElement);
        waveCanvas.style.position = 'absolute';
        waveCanvas.style.top = computedStyle.top || '-3vw';
        waveCanvas.style.left = computedStyle.left || '70%';
        waveCanvas.style.width = computedStyle.width || '15vw';
        waveCanvas.style.height = 'auto';
        waveCanvas.style.transform = computedStyle.transform || 'rotate(-15deg)';
        waveCanvas.style.zIndex = '6';
        waveCanvas.style.pointerEvents = 'none';
        waveCanvas.style.mixBlendMode = 'screen';
        waveCanvas.style.opacity = '0.9';
        
        // Remplacer l'image par le canvas
        waveElement.parentNode.insertBefore(waveCanvas, waveElement);
        waveElement.style.display = 'none';
        
        // Initialiser Three.js pour l'effet wave
        initWaveThreeJS();
    }

    function initWaveThreeJS() {
        // Vérifier que Three.js est chargé
        if (typeof THREE === 'undefined') {
            console.error('Three.js n\'est pas chargé pour l\'effet wave');
            // Fallback : montrer l'image originale
            if (waveElement) {
                waveElement.style.display = '';
            }
            if (waveCanvas && waveCanvas.parentNode) {
                waveCanvas.parentNode.removeChild(waveCanvas);
                waveCanvas = null;
            }
            return;
        }
        
        // Scène
        waveScene = new THREE.Scene();
        
        // Caméra
        waveCamera = new THREE.OrthographicCamera(-1, 1, 1, -1, 0, 1);
        
        // Renderer
        waveRenderer = new THREE.WebGLRenderer({
            canvas: waveCanvas,
            alpha: true,
            antialias: false,
            precision: 'highp'
        });
        
        // Taille responsive
        const updateWaveSize = () => {
            const isMobile = window.innerWidth <= 768;
            const canvasWidth = isMobile ? window.innerWidth * 0.25 : window.innerWidth * 0.15;
            const canvasHeight = canvasWidth * 0.6; // Ratio approximatif de l'image
            
            waveRenderer.setSize(canvasWidth, canvasHeight);
            waveRenderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
        };
        
        updateWaveSize();
        window.addEventListener('resize', updateWaveSize);
        
        // Shader avec effet de vague liquide
        const waveShader = {
            uniforms: {
                uTexture: { value: null },
                uTime: { value: 0 },
                uWaveIntensity: { value: 0.8 }
            },
            vertexShader: `
                varying vec2 vUv;
                void main() {
                    vUv = uv;
                    gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
                }
            `,
            fragmentShader: `
                uniform sampler2D uTexture;
                uniform float uTime;
                uniform float uWaveIntensity;
                varying vec2 vUv;
                
                void main() {
                    vec2 uv = vUv;
                    
                    // Effets de vagues multiples pour un mouvement plus complexe
                    float wave1 = sin(uv.x * 8.0 + uTime * 1.2) * 0.02;
                    float wave2 = cos(uv.y * 6.0 + uTime * 0.8) * 0.02;
                    float wave3 = sin(uv.x * 4.0 + uv.y * 4.0 + uTime * 1.5) * 0.015;
                    
                    // Vagues circulaires pour plus de dynamisme
                    float dist = distance(uv, vec2(0.5, 0.5));
                    float circularWave = sin(dist * 10.0 - uTime * 2.0) * 0.01;
                    
                    // Combine toutes les vagues
                    vec2 distortion = vec2(
                        wave1 + wave3 + circularWave,
                        wave2 + wave3 + circularWave
                    ) * uWaveIntensity;
                    
                    uv += distortion;
                    
                    // Échantillonner la texture avec la distortion
                    vec4 color = texture2D(uTexture, uv);
                    
                    // Effet de brillance subtile
                    float glow = 1.0 + sin(uTime * 0.5) * 0.1 + cos(uTime * 0.3) * 0.05;
                    color.rgb *= glow;
                    
                    // Légère saturation pour plus d'impact
                    float saturation = 1.1;
                    float gray = dot(color.rgb, vec3(0.299, 0.587, 0.114));
                    color.rgb = mix(vec3(gray), color.rgb, saturation);
                    
                    gl_FragColor = color;
                }
            `
        };
        
        // Matériau avec shader
        waveMaterial = new THREE.ShaderMaterial(waveShader);
        
        // Géométrie plane
        const geometry = new THREE.PlaneGeometry(2, 2);
        waveMesh = new THREE.Mesh(geometry, waveMaterial);
        waveScene.add(waveMesh);
        
        // Charger l'image
        loadWaveTexture();
        
        // Démarrer l'animation
        animateWaveThreeJS();
    }

    function loadWaveTexture() {
        if (!waveElement) return;
        
        const imageSrc = waveElement.src;
        const loader = new THREE.TextureLoader();
        
        loader.load(
            imageSrc,
            (texture) => {
                // Configuration de la texture
                texture.wrapS = THREE.ClampToEdgeWrapping;
                texture.wrapT = THREE.ClampToEdgeWrapping;
                texture.minFilter = THREE.LinearFilter;
                texture.magFilter = THREE.LinearFilter;
                texture.generateMipmaps = false;
                texture.flipY = true;
                texture.needsUpdate = true;
                
                waveTexture = texture;
                waveMaterial.uniforms.uTexture.value = waveTexture;
            },
            undefined,
            (error) => {
                console.error('Erreur de chargement de la texture wave:', error, imageSrc);
                // Fallback : montrer l'image originale en cas d'erreur
                if (waveElement) {
                    waveElement.style.display = '';
                }
                if (waveCanvas && waveCanvas.parentNode) {
                    waveCanvas.parentNode.removeChild(waveCanvas);
                    waveCanvas = null;
                }
            }
        );
    }

    function animateWaveThreeJS() {
        if (!waveRenderer || !waveScene || !waveCamera) return;
        
        waveCurrentTime += 0.016; // ~60fps
        
        // Mettre à jour les uniformes du shader 
        if (waveMaterial && waveMaterial.uniforms) {
            if (waveMaterial.uniforms.uTime) {
                waveMaterial.uniforms.uTime.value = waveCurrentTime;
            }
        }
        
        // Render
        waveRenderer.render(waveScene, waveCamera);
        
        // Continuer l'animation
        requestAnimationFrame(animateWaveThreeJS);
    }

    function cleanupWaveEffect() {
        if (waveCanvas && waveCanvas.parentNode) {
            waveCanvas.parentNode.removeChild(waveCanvas);
        }
        if (waveRenderer) {
            waveRenderer.dispose();
        }
        if (waveTexture) {
            waveTexture.dispose();
        }
        if (waveElement) {
            waveElement.style.display = '';
        }
        
        waveCanvas = null;
        waveScene = null;
        waveRenderer = null;
        waveMaterial = null;
        waveMesh = null;
        waveCamera = null;
        waveTexture = null;
        waveElement = null;
    }

    function handleWaveResize() {
        // Si on passe à un très petit écran, nettoyer l'effet
        if (window.innerWidth <= 575 && waveCanvas) {
            cleanupWaveEffect();
            // S'assurer que l'image originale est visible après nettoyage
            waveElement = document.querySelector('.wave');
            if (waveElement) {
                waveElement.style.display = '';
            }
        }
        // Si on revient à un écran plus grand et qu'il n'y a pas d'effet, le créer
        else if (window.innerWidth > 575 && !waveCanvas) {
            setTimeout(() => {
                createWaveCanvas();
            }, 100);
        }
    }
